/**
 * Centraliza cálculos de valor de faturamento no frontend.
 * Espelha a lógica do FaturamentoCalculoHelper.cs no backend
 * para garantir consistência entre telas.
 *
 * Regra única:
 *   1. Minutos já vêm truncados do backend (Duration/60L).
 *   2. Valor = Math.round(totalMinutos / 60 * valorHora * 100) / 100.
 *      NÃO arredondar horas antes de multiplicar — arredondar somente o resultado final.
 *   3. Horas para exibição (display): Math.round(totalMinutos / 60 * 100) / 100 — SEPARADO do cálculo de valor.
 */

/**
 * Calcula o valor monetário a partir de minutos e valor hora.
 * Usa minutos exatos divididos por 60 e arredonda somente o resultado final.
 */
export function calcularValor(totalMinutos: number, valorHora: number): number {
  return Math.round((totalMinutos / 60) * valorHora * 100) / 100
}

/**
 * Converte minutos para horas decimais arredondadas (2 casas).
 * ATENÇÃO: Usar apenas para display. Para cálculo de valor, usar calcularValor().
 */
export function minutosParaHorasDecimais(totalMinutos: number): number {
  return Math.round((totalMinutos / 60) * 100) / 100
}

/**
 * Soma minutos de uma lista de apontamentos.
 * Cada apontamento já tem `minutos` truncado (sem segundos residuais).
 */
export function somarMinutosApontamentos(apontamentos: Array<{ minutos?: number | null }>): number {
  return apontamentos.reduce((acc, entry) => acc + (entry.minutos || 0), 0)
}
